export default __webpack_public_path__ + "static/media/KeshavMandal.781ce4c8.pdf";